/**
 * Mobile Convenience Fees Display
 * Re-exports the unified ConvenienceFeesSection with mobile variant as default
 * 
 * @deprecated Import from '@/components/residents/payments/shared' instead
 */

import React from 'react';
import { ConvenienceFeesSection } from '@/components/residents/payments/shared/ConvenienceFeesSection';
import type { FeeStructure } from '@/types/residents/payment';

interface ConvenienceFeesDisplayProps {
  feeStructure: FeeStructure;
  style?: any;
}

export const ConvenienceFeesDisplay: React.FC<ConvenienceFeesDisplayProps> = ({
  feeStructure,
  style,
}) => {
  return (
    <ConvenienceFeesSection
      feeStructure={feeStructure}
      variant="mobile"
      showHeader={true}
      style={style}
    />
  );
};
